import { StarIcon } from "@heroicons/react/24/solid";
import React, { FC } from "react";
import API_HOST from '../config/config';
import { useAuth  } from '../contains/AuthContext';
import Avatar from "shared/Avatar/Avatar";

interface ReviewItemDataType {
  name: string;
  avatar?: string;
  date: string;
  comment: string;
  starPoint: number;
}

export interface ReviewItemProps {
  className?: string;
  data?: any;
}

const DEMO_DATA: ReviewItemDataType = {
  name: "Cody Fisher",
  date: "May 20, 2021",
  comment:
    "Very nice feeling sweater. I like it better than a regular hoody because it is tailored to be a slimmer fit. Perfect for going out when you want to stay comfy. The head opening is a little tight which makes it a little.",
  starPoint: 5,
};

const ReviewItem: FC<ReviewItemProps> = ({
  className = "",
  data = [],
}) => {
  const { user } = useAuth();
  return (
    <div
      className={`nc-ReviewItem flex flex-col ${className}`}
      data-nc-id="ReviewItem"
    >
      <div className=" flex space-x-4 ">
        <div className="flex-shrink-0 pt-0.5">
          <Avatar
            sizeClass="h-10 w-10 text-lg"
            radius="rounded-full"
            userName={user?.name}
            imgUrl={user?.image}
          />
        </div>

        <div className="flex-1 flex justify-between">
          <div className="text-sm sm:text-base">
            <span className="block font-semibold">{user?.name}</span>
            <span className="block mt-0.5 text-slate-500 dark:text-slate-400 text-sm">
              {data?.product_review?.['posted_dt' as any]}
            </span>
          </div>

          <div className="mt-0.5 flex">
            {[...Array(5)].map((_, index) => {
              const starValue = index + 1;
              return (
                <span
                  key={index}
                  className={ (starValue <= data?.product_review?.['rate' as any]) ? 'text-custom-golden' : '' }
                >
                  <StarIcon className="w-5 h-5" />
                </span>
              );
            })}
          </div>
        </div>
      </div>
      <div className="mt-4 prose prose-sm sm:prose dark:prose-invert sm:max-w-2xl">
        <p className="text-slate-600 dark:text-slate-300">{data?.product_review?.['review' as any]}</p>
      </div>
    </div>
  );
};

export default ReviewItem;
